import { useMemo } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { useAuth } from '@/auth/hooks/useAuth';
import { GameStateListPage } from './GameStateListPage';
import { GameStateDetailPage } from './GameStateDetailPage';
import { AdminDashboardPage } from './AdminDashboardPage';
import { AdminUserLookupPage } from './AdminUserLookupPage';
import { AdminUserStatesPage } from './AdminUserStatesPage';
import { AdminUserStateDetailPage } from './AdminUserStateDetailPage';
import { AdminAuditLogPage } from './AdminAuditLogPage';

export function DfeGameStateArchePage() {
  const { user } = useAuth();
  const isAdmin = useMemo(() => user?.roles?.includes('admin') ?? false, [user?.roles]);

  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<GameStateListPage />} />
        <Route path="/:keyword" element={<GameStateDetailPage />} />
        {isAdmin ? (
          <>
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/admin/users" element={<AdminUserLookupPage />} />
            <Route path="/admin/users/:userId" element={<AdminUserStatesPage />} />
            <Route path="/admin/users/:userId/:keyword" element={<AdminUserStateDetailPage />} />
            <Route path="/admin/audit" element={<AdminAuditLogPage />} />
          </>
        ) : (
          <Route path="/admin/*" element={<Navigate to="/" replace />} />
        )}
      </Routes>
    </ArcheLayout>
  );
}
